import React from 'react';
import { styled } from '@mui/material';

import ProjectCard from 'components/organisms/CourseDashboard/ProjectCard';
import { Box } from 'shell/components';

const ProjectList = styled(Box)(({ device, theme }) => {
    return {
        display: 'grid',
        gap: theme.spacing(5),
        ...(device === 'desktop'
            ? {
                  gridTemplateColumns: '50% 50%',
              }
            : {
                  gridTemplateColumns: '100%',
              }),
    };
});

const ProjectsOverview = ({
    device,
    role,
    project,
    numGroups,
    selectProject,
    setProjectSettings,
    handleProjectCardDropdown,
}) => {
    return (
        <ProjectList device={device}>
            <ProjectCard
                role={role}
                project={project}
                numGroups={numGroups}
                selectProject={selectProject}
                setProjectSettings={setProjectSettings}
                handleProjectCardDropdown={handleProjectCardDropdown}
            />
        </ProjectList>
    );
};

export default ProjectsOverview;
